import { simpleTransform } from 'sanitize-html';
import { SANITIZE_PROFILE_DEFAULT } from './default';
import { SANITIZE_PROFILE_EMAIL } from './email';
export const SANITIZE_PROFILE_EMAIL_SHADOW_DOM = {
    allowedTags: [
        ...SANITIZE_PROFILE_EMAIL.allowedTags,
        // Not including <title> in the allowed tags tells the library to "santize" the tag
        // by removing the enclosing tag and leaving the content in the DOM. We add it to
        // the list of allowed tags, so that it could be removed later on by the exclusiveFilter function.
        ...['style', 'title'],
    ],
    allowedAttributes: Object.assign(Object.assign({}, SANITIZE_PROFILE_EMAIL.allowedAttributes), { font: ['face'] }),
    allowedSchemes: SANITIZE_PROFILE_DEFAULT.allowedSchemes,
    transformTags: {
        // Links should open in a new tab.
        a: simpleTransform('a', { target: '_blank', rel: 'noopener noreferrer' }),
    },
    exclusiveFilter: (element) => {
        var _a;
        return (((_a = SANITIZE_PROFILE_EMAIL.exclusiveFilter) === null || _a === void 0 ? void 0 : _a.call(SANITIZE_PROFILE_EMAIL, element)) ||
            // Remove the title tag along with its text content.
            element.tag === 'title');
    },
    // To suppress the warning about including style tags in the allowedTags
    allowVulnerableTags: true,
};
